import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

/**
 * Exit-intent newsletter popup. Shows once per session.
 */
export const ExitIntentPopup = () => {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("sa.exit-shown")) return;
    // Never interrupt a user who is actively using the Business Builder,
    // and never show on trend pages (that's where users build businesses).
    const bbActive = () =>
      window.location.pathname.startsWith("/trend/") ||
      document.querySelector("[data-testid='business-builder']");
    let timer;
    const handler = (e) => {
      if (e.clientY < 10 && !bbActive()) {
        sessionStorage.setItem("sa.exit-shown", "1");
        setOpen(true);
        document.removeEventListener("mouseout", handler);
      }
    };
    // Show on first mouseout near top of screen, OR after 30s on page
    timer = setTimeout(() => {
      if (!sessionStorage.getItem("sa.exit-shown") && !bbActive()) {
        sessionStorage.setItem("sa.exit-shown", "1");
        setOpen(true);
      }
    }, 30000);
    document.addEventListener("mouseout", handler);
    return () => {
      document.removeEventListener("mouseout", handler);
      clearTimeout(timer);
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      await api.post("/newsletter/subscribe", { email });
      setDone(true);
      setTimeout(() => setOpen(false), 1800);
    } catch (e) {
      console.warn("newsletter subscribe failed", e);
    }
  };

  if (!open) return null;
  return (
    <div
      data-testid="exit-intent-popup"
      className="fixed inset-0 z-[100] bg-black/70 flex items-center justify-center p-4"
      onClick={() => setOpen(false)}
    >
      <div
        className="bg-white border border-black max-w-lg w-full p-8 lg:p-10 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          data-testid="exit-popup-close"
          onClick={() => setOpen(false)}
          className="absolute top-4 right-4 overline border border-black px-2 py-1 hover:bg-black hover:text-white"
        >
          ×
        </button>
        <div className="overline text-[#52525b] mb-4">Wait — one more thing</div>
        {!done ? (
          <>
            <h3 className="font-display font-extrabold text-3xl lg:text-4xl tracking-tighter leading-[1] mb-3">
              Get the world&apos;s most surprising searches —{" "}
              <span className="text-[#ff3b30]">every Monday.</span>
            </h3>
            <p className="text-sm text-[#52525b] mb-6">
              One quiet email. 10 hand-picked trends from 12 countries. Unsubscribe in one click.
            </p>
            <form onSubmit={submit} className="flex border border-black">
              <input
                data-testid="exit-popup-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@curious.world"
                className="flex-1 px-4 py-3 font-mono text-sm focus:outline-none"
              />
              <button
                data-testid="exit-popup-submit"
                type="submit"
                className="bg-black text-white px-5 overline hover:bg-[#ff3b30]"
              >
                Subscribe →
              </button>
            </form>
            <Link
              to="/sponsor"
              data-testid="exit-popup-sponsor-link"
              className="block mt-5 font-mono text-xs text-[#52525b] hover:text-black"
            >
              Or sponsor this site for as little as $99/week →
            </Link>
          </>
        ) : (
          <div className="text-center py-8">
            <div className="font-display font-extrabold text-3xl">You&apos;re in.</div>
            <div className="font-mono text-xs text-[#52525b] mt-3">See you Monday.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ExitIntentPopup;
